export default {
  'promoHeader': 'Du glömmer väl inte?',
  'add':'Lägg till',
  'pickSize':'Välj storlek',
  'cartHeader':'Din varukorg:',
  'addUniid':'Lägg till namn och nummer',
  'remove':'Ta bort',
  'freeDelivery':'Du har uppnått fri frakt!',
  'toCheckout':'Gå till betalning',
  'totalPrice':'Totalpris:',
  'totalDiscount':'Sammanlagd rabatt:',
  'deliveryPrice':'Fraktkostnad:',
  'size':'Storlek:',
  'getTomoz':'',
  'totalVAT':'Moms:',
  'consent': 'Yes - I allow Unisport to send me email and sms\'s on similar football products. I can unsubscribe at any time in the email or by un-ticking this box, should the communication not be as expected.'
}